import { ThreadPost } from './ThreadPost';
import { Post, DummyPlainObject } from './Post';
import { PostList } from './PostList';


export class ThreadFirstPost extends Post {
  private commentList: PostList<ThreadPost> = new PostList();
  private _lastupdate: Date = new Date();

  public constructor(private _title: string, private threadPost: ThreadPost) { 
    super();
  }

  public get lastupdate(): Date {
    return this._lastupdate;
  }

  public update(): void {
    this._lastupdate = new Date();
  }

  public get title(): string {
    return this._title;
  }

  public get shortTitle(): string {
    const len = 22;
    const shortTitle = this._title.length <= len ? this._title : (this._title.substr(0, len) + "...");
    return shortTitle;
  }
  
  public get id(): string {
    return this.threadPost.id;
  }

  public get content(): string {
    return this.threadPost.content;
  }

  public get username(): string {
    return this.threadPost.username;
  }
  public get timestamp(): Date {
    return this.threadPost.timestamp;
  }
  public get ymd(): string{
    return this.threadPost.ymd;
  }
  public get hi(): string {
    return this.threadPost.hi;
  }
  public get responseCount(): number {
    return this.commentList.count();
  }
  public get lastUpdate(): Date {
    return this.postList.lastUpdate();
  }
  public hasChildren(): boolean {
    return true;
  }
  public get postList(): PostList<Post> {
    return this.commentList;
  }

  public toPlainObject(): Object {
    const plainObject: DummyPlainObject = {
      id: this.id,
      title: this.title,
      contents: this.content,
      username: this.username,
      timestamp: this.timestamp,
      list: this.commentList.toPlainObject()
    };

    //console.log(111, this.commentList.toPlainObject2(), this.commentList);

    return plainObject;
  }
}